import { StoreState } from "../../../apps/containers/AppContainer/StoreState";
import BarrelHelpers from "../../../apps/data/barrel/BarrelHelpers";

import { StoreProps } from "./PlatformSwitcherProps";

export function mapStateToProps({
    UserStore: {
        platformSwitcherPromotionSeen
    }
}: StoreState): StoreProps {
    const platform = BarrelHelpers.getPlatform();

    return {
        platform,
        platformSwitcherPromotionSeen
    };
}
